<template>
    <el-dialog :title="title" width="60%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-row :gutter="10" v-show="step == 1" class="p_b2">
            <el-col :span="12">
                <el-card shadow="hover" class="text_center pointer" @click.native="selCheck(2)">
                    <div class="el-icon-coin icon"></div>
                    <div class="title">一致性检核</div>
                    <div class="tips"> 用于检查元数据模板下含有重复的元数据字段</div>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card shadow="hover" class="text_center pointer" @click.native="selCheck(3)">
                    <div class="el-icon-cpu icon"></div>
                    <div class="title">值域检核</div>
                    <div class="tips"> 用于检查元数据模板设置规则后是否设置了值域</div>
                </el-card>
            </el-col>
        </el-row>
        <div v-if="step != 1">
            <el-table
                    :data="dataList"
                    v-loading="loading"
                    size="small" max-height="calc(100vh - 200px)"
                    class="table" border :empty-text="emptyText">
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column type="basicRename" label="重复别名" show-overflow-tooltip v-if="step == 2"></el-table-column>
                <el-table-column prop="basicName" label="元数据名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="position" label="所处位置" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicType" label="元数据类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("basic_type", row.basicType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="assemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="checkResult" label="检查结果" show-overflow-tooltip v-if="step == 3"></el-table-column>
            </el-table>
            <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                        @pagination="refreshList"/>
        </div>
        <div slot="footer" class="text_center" v-if="step != 1">
            <el-button size="small" @click="step = 1">返回</el-button>
            <el-button size="small" type="primary" @click="exportData()" v-noMoreClick>导出</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '模型检查',
                emptyText: '暂无数据',
                step: 1,
                dataList: [],
                searchForm: {
                    current: 1,
                    size: 20,
                    basicDataId: '',
                },
                total: 0,
            }
        },
        watch: {
            'step'(val) {
                if(val == 1) {
                    this.title = '模型检查'
                } else if(val == 2) {
                    this.emptyText = '暂无重复别名'
                    this.title = '一致性检查结果'
                } else if(val == 3) {
                    this.emptyText = "元数据模板相关组件均已设置值域"
                    this.title = '值域检核结果'
                }
            },
        },
        methods: {
            init(basicDataId) {
                this.step = 1
                this.searchForm.basicDataId = basicDataId
                this.visible = true
            },
            refreshList() {
                let api = this.api.metadata.consistencycheck
                if(this.step == 3) {
                    api = this.api.metadata.codomaincheck
                }
                this.$axios(api, this.searchForm).then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    } else {
                        this.$message.error('查询失败');
                    }
                })
            },
            // 选择检核
            selCheck(type) {
                this.dataList = []
                this.step = type
                this.refreshList()
            },
            // 导出
            exportData() {
                if(!this.dataList.length) {
                    this.$message.warning('暂无可导出的数据')
                    return
                }
                let api = this.api.metadata.consistencycheckExport
                if(this.step == 3) {
                    api = this.api.metadata.codomainCheckExport
                }
                this.exportExcel(api, {basicDataId: this.searchForm.basicDataId}, this.title, 'post')
            }
        }
    }
</script>

<style scoped>
    .icon {
        font-size: 45px;
        margin-bottom: 10px;
        font-weight: bold;
    }
    .title {
        font-size: 18px;
        padding-bottom: 8px;
    }
    .tips {
        font-size: 12px;
        color: #ababab;
    }
</style>
